import { render, staticRenderFns } from "./PedidosRedirect.vue?vue&type=template&id=0bfda8a4&"
import script from "./PedidosRedirect.vue?vue&type=script&lang=js&"
export * from "./PedidosRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports